import axios from "axios";
import { API_HOST } from "config";

let isRefreshing = false;
let failedQueue = [];

const processQueue = (error) => {
    failedQueue.forEach((prom) => {
        if (error) {
            prom.reject(error);
        } else {
            prom.resolve();
        }
    });
    failedQueue = [];
};

function getCookie(name) {
    return document.cookie
        .split("; ")
        .find((row) => row.startsWith(name + "="))
        ?.split("=")[1];
}

const getHeaders = () => {
    const headers = {
        "Content-Type": "application/json",
    };
    const csrf = getCookie("csrftoken");
    if (csrf) {
        headers["X-CSRFToken"] = csrf;
    }
    return headers;
};

export const apiClient = axios.create({
    baseURL: API_HOST + "/api",
    headers: getHeaders(),
    withCredentials: true,
});

apiClient.interceptors.request.use(
    (config) => {
        config.headers = getHeaders();
        return config;
    },
    (error) => {
        return Promise.reject(error);
    },
);

apiClient.interceptors.response.use(
    (response) => response,
    async (error) => {
        const originalRequest = error.config;

        // Handle global errors here (e.g., unauthorized, server errors)
        if (error.response && error.response.status === 401 && !originalRequest._retry) {
            if (isRefreshing) {
                // If already refreshing, queue this request
                return new Promise((resolve, reject) => {
                    failedQueue.push({ resolve, reject });
                })
                    .then(() => {
                        return apiClient(originalRequest);
                    })
                    .catch((err) => {
                        return Promise.reject(err);
                    });
            }

            originalRequest._retry = true;
            isRefreshing = true;

            try {
                // Attempt to refresh the token using the refresh cookie
                await axios.post(
                    `${API_HOST}/api/users/token/refresh/`,
                    {},
                    {
                        withCredentials: true,
                        headers: {
                            "Content-Type": "application/json",
                            "X-CSRFToken": getCookie("csrftoken"),
                        },
                    }
                );

                // Token refreshed successfully (new cookie set by server)
                // Process queued requests
                processQueue(null);
                isRefreshing = false;
                
                // Retry the original request
                return apiClient(originalRequest);
            } catch (refreshError) {
                // Refresh failed, clear state and redirect
                processQueue(refreshError);
                isRefreshing = false;
                clearAuthTokens();
                // window.location.href = "/login"; // Uncomment to enable redirect
                return Promise.reject(refreshError);
            }
        }
        
        return Promise.reject(error);
    }
);


export const clearAuthTokens = () => {
    // Clear cookies by setting them to expire
    document.cookie = "access=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;";
    document.cookie = "refresh=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;";
};